import dayjs, { type Dayjs } from "dayjs";
import {
    ENQUIRY_DATE_DISPLAY_FORMAT,
    ENQUIRY_TIMESTAMP_FIELD_KEYS,
} from "./enquiry-settings";
import type { EnquiryDateRangeFilter } from "./enquiry-date-range";

export const resolveEnquiryTimestamp = (
    record: Record<string, unknown>
): string | number | undefined => {
    for (const key of ENQUIRY_TIMESTAMP_FIELD_KEYS) {
        const value = record[key];
        if (value != null && value !== "") return value as string | number;
    }
    return undefined;
};

export const parseEnquiryTimestamp = (value?: string | number | null): Dayjs | null => {
    if (value == null || value === "") return null;
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed : null;
};

export const getEnquiryTimestampMs = (value?: string | number | null) =>
    parseEnquiryTimestamp(value)?.valueOf() ?? 0;

export const formatEnquiryDate = (value?: string | number | null) => {
    const parsed = parseEnquiryTimestamp(value);
    return parsed ? parsed.format(ENQUIRY_DATE_DISPLAY_FORMAT) : "-";
};

export const isEnquiryInDateRange = (
    value: string | number | undefined,
    range: EnquiryDateRangeFilter
) => {
    if (range.preset === "all" && !range.from && !range.to) return true;

    const parsed = parseEnquiryTimestamp(value);
    if (!parsed) return false;

    const now = dayjs();
    if (range.preset === "today") return parsed.isSame(now, "day");
    if (range.preset === "last7") return now.diff(parsed, "day") <= 7;
    if (range.preset === "last30") return now.diff(parsed, "day") <= 30;

    const from = range.from ? dayjs(range.from).startOf("day") : null;
    const to = range.to ? dayjs(range.to).endOf("day") : null;

    if (from?.isValid() && parsed.isBefore(from)) return false;
    if (to?.isValid() && parsed.isAfter(to)) return false;

    return true;
};
